import type { MatterSearchResult } from "@/lib/data/requests/matters/search-matters";
import { formatContactsName, formatUsersName } from "@/lib/utils/format";

type MatterSearchResultAssignee = NonNullable<
  MatterSearchResult["assignees"]
>[number] & {
  matterAssigneeDateTimeEnd?: string | null;
  user?: {
    firstName?: string | null;
    lastName?: string | null;
  } | null;
};

const isActiveAssignee = (assignee: MatterSearchResultAssignee) =>
  !assignee.dateTimeEnd && !assignee.matterAssigneeDateTimeEnd;

const getAssigneeDisplayName = (assignee: MatterSearchResultAssignee) => {
  const formatted =
    formatUsersName(assignee.user)?.trim() ||
    [assignee.user.firstName, assignee.user.lastName]
      .map((part) => part.trim())
      .filter(Boolean)
      .join(" ");

  return formatted || undefined;
};

export const getMatterSearchResultAssigneeDisplayNames = (
  matter: Pick<MatterSearchResult, "assignees">,
): string[] =>
  (matter.assignees ?? [])
    .filter(isActiveAssignee)
    .map(getAssigneeDisplayName)
    .filter((name): name is string => Boolean(name));

export const getMatterSearchResultClientConnection = (
  matter: Pick<MatterSearchResult, "connections">,
) =>
  (matter.connections ?? []).find(
    (connection) => connection.connectionType === "matter_to_client",
  );

export const getMatterSearchResultClientName = (
  matter: Pick<MatterSearchResult, "connections">,
) =>
  formatContactsName(
    getMatterSearchResultClientConnection(matter)?.contact ?? undefined,
  ) ?? "";
